/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { DietaryTargetsResponse } from './dietary-targets-response';
// May contain unused imports in some cases
// @ts-ignore
import { PlanOptionSubscriptionResponse } from './plan-option-subscription-response';
// May contain unused imports in some cases
// @ts-ignore
import { PlanPartnerResponse } from './plan-partner-response';
// May contain unused imports in some cases
// @ts-ignore
import { SubscriptionActionResponse } from './subscription-action-response';
// May contain unused imports in some cases
// @ts-ignore
import { SubscriptionInvoiceResponse } from './subscription-invoice-response';

/**
 * 
 * @export
 * @interface SubscriptionResponse
 */
export interface SubscriptionResponse {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionResponse
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'status'?: SubscriptionResponseStatusEnum;
    /**
     * 
     * @type {PlanPartnerResponse}
     * @memberof SubscriptionResponse
     */
    'partner'?: PlanPartnerResponse;
    /**
     * 
     * @type {PlanOptionSubscriptionResponse}
     * @memberof SubscriptionResponse
     */
    'planOption'?: PlanOptionSubscriptionResponse;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'endDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionResponse
     */
    'remainingDays'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionResponse
     */
    'daysToStart'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionResponse
     */
    'cancellable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionResponse
     */
    'cancelled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'cancellationDate'?: string;
    /**
     * 
     * @type {Array<SubscriptionActionResponse>}
     * @memberof SubscriptionResponse
     */
    'actions'?: Array<SubscriptionActionResponse>;
    /**
     * 
     * @type {DietaryTargetsResponse}
     * @memberof SubscriptionResponse
     */
    'dietaryTargets'?: DietaryTargetsResponse;
    /**
     * 
     * @type {Array<string>}
     * @memberof SubscriptionResponse
     */
    'deliveryDays'?: Array<SubscriptionResponseDeliveryDaysEnum>;
    /**
     * 
     * @type {SubscriptionInvoiceResponse}
     * @memberof SubscriptionResponse
     */
    'invoice'?: SubscriptionInvoiceResponse;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'discountCode'?: string;
}

export const SubscriptionResponseStatusEnum = {
    Active: 'ACTIVE',
    Future: 'FUTURE',
    Past: 'PAST',
    Cancelled: 'CANCELLED'
} as const;

export type SubscriptionResponseStatusEnum = typeof SubscriptionResponseStatusEnum[keyof typeof SubscriptionResponseStatusEnum];
export const SubscriptionResponseDeliveryDaysEnum = {
    Monday: 'MONDAY',
    Tuesday: 'TUESDAY',
    Wednesday: 'WEDNESDAY',
    Thursday: 'THURSDAY',
    Friday: 'FRIDAY',
    Saturday: 'SATURDAY',
    Sunday: 'SUNDAY'
} as const;

export type SubscriptionResponseDeliveryDaysEnum = typeof SubscriptionResponseDeliveryDaysEnum[keyof typeof SubscriptionResponseDeliveryDaysEnum];


